import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as select from '../data/selectors'
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const OutletSearch = ({ name, isTxn, isLabel, label, isSelection, placeholder, getValue: callback }, props) => {


    const options = useSelector(state => select.selectOutlet(state, props))
    
    const getValue = (value, setFieldValue) => {
        if (callback) {
            callback(value, setFieldValue)
        }
    }


    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} placeholder={placeholder} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue }}> </Field>

    )
}

export default OutletSearch;
